import { defineStore } from 'pinia'

export const InfoBlock = defineStore({
    id: 'wp_info_document',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
export const MiniInfoBlock = defineStore({
    id: 'wp_info_document__mini',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const SpecialBlock = defineStore({
    id: 'wp_spec_document',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const SortBy = defineStore({
    id: 'wp_sort_by',
    state: () => {
        return { value: {
                name: 'Физ. Объект',
                field: 'object',
                group: true,
                icon: 'circle'
            } }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const SortDirReverse = defineStore({
    id: 'wp_sort_direction',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
